module.exports = __webpack_public_path__ + "static/media/PO.2b57e84a.svg";